import React, { Component } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col  from "react-bootstrap/Col";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import ReactTooltip from "react-tooltip";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { filterByLanguage, copyReplaceAt } from "../../../utils/functions.js";
import { checkDatasetIdentifier } from "../../../utils/DatasetAPI.js";
import BootstrapSwitchButton from 'bootstrap-switch-button-react'

export class DatasetModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show: this.props.show,
      error: false,
      identifierExists: false,
      class: null,
      privat: this.props.dataset ? !this.props.dataset.public : false,
      location: this.props.dataset && this.props.dataset.remoteTripleStore ? "REMOTE" : 'LOCAL',
      datatype: this.props.dataset && this.props.dataset.datatype ? this.props.dataset.datatype : 'RDF',

      projects: this.props.dataset && this.props.dataset.projects ? this.props.dataset.projects : [],

      multiGroup: this.props.dataset ? this.props.dataset.multiGroup : false
    }
    this.projects = [];
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  addProject() {
    this.setState({ projects: this.state.projects.slice().concat('')});
  }

  deleteTask(index) {
    this.setState({ projects: this.state.projects.slice(0, index).concat(this.state.projects.slice(index + 1)) }
    // ,
    //   () => {
    //   for (var i in this.state.projects)  {
    //     this.tasks[i].value = this.state.tasks[i].type
    //   }}
    )
  }

  projectChanged(index, event) {
    this.setState(copyReplaceAt('projects', this.state.projects, index, { type: event.target.value}))
  }

  existsDatasetIdentifier() {
    if (this.identifier.value) {
      checkDatasetIdentifier(this.identifier.value, this.props.dataset ? this.props.dataset.id : null, this.props.selectedProject ? this.props.selectedProject.id : null)
      .then(text => {
        if (!text.data.valid || text.data.exists) {
           this.setState( {identifierExists : true })
        } else
            this.setState( {identifierExists : false })
        })
      }
    return false
   }

   templateChanged() {
     this.setState({ template: this.props.templates.filter(el => el.id === this.template.value)[0] })
   }

  classChanged() {
    this.setState( { class : this.class.value })
  }

  locationChanged() {
    this.setState( { location : this.location.value })
  }

  formIsValid() {
    var ok = !(this.identifier && this.identifier.value && ((!this.props.dataset && this.state.identifierExists) || (this.props.dataset && this.state.identifierExists && this.props.dataset.identifier !== this.identifier.value)));
    if (!ok) {
      return ok;
    }

    if (this.state.location == 'REMOTE' && !this.sparqlEndpoint.value) {
      return false;
    }

    return ok;
  }

  handleSubmit(event) {
     event.preventDefault();

      if (this.formIsValid()) {

        var newTemplate = null;
        if (this.state.template) {
          var params = [];
          newTemplate = this.state.template;
          for (const i in this.state.template.parameters) {
            params.push({ name: this.state.template.parameters[i].name, value: this['template-parameter-' + this.state.template.parameters[i].name].value })
            newTemplate = {...this.state.template, parameters: params };
          }
        }

        var entityDescriptors = undefined;
        if (this.datatype && this.datatype.value == 'RDF' && this.namespace && this.prefix) {
          entityDescriptors = [ { namespace: this.namespace.value, prefix: this.prefix.value} ]
        }

        var publicGraphs = []
        if (this.datatype && this.datatype.value == 'RDF' && this.multiGroup && this.multiGroup.checked &&  this.publicGroups.value) {
          for (var g of this.publicGroups.value.split(",")) {
            publicGraphs.push(g.trim());
          }
        }

        this.props.onOK(this.props.dataset ? this.props.dataset.id : null,
                        newTemplate,
                        this.name.value,
                        this.identifier ? this.identifier.value : undefined,
                        this.props.visibility ? this.state.privat : false,
                        this.datatype ? this.datatype.value : undefined,
                        // this.tripleStore ? this.tripleStore.value : undefined,
                        this.type ? this.type.value : undefined,
                        this.property && this.datatype && this.datatype.value == 'RDF' ? this.property.value : undefined,
                        this.class && this.datatype && this.datatype.value == 'RDF' ? this.class.value : undefined,
                        this.ontology && this.datatype && this.datatype.value == 'RDF' ? this.props.database.resourcePrefix + 'dataset/' + this.ontology.value : undefined,
                        this.multiGroup && this.datatype && this.datatype.value == 'RDF' ? this.multiGroup.checked : false,
                        publicGraphs,
                        this.sparqlEndpoint && this.datatype && this.datatype.value == 'RDF' ? this.sparqlEndpoint.value : undefined,
                        this.namedGraph && this.datatype && this.datatype.value == 'RDF' ? this.namedGraph.value : undefined,
                        this.lastUpdatedSparqlQuery && this.datatype && this.datatype.value == 'RDF' ? this.lastUpdatedSparqlQuery.value : undefined,
                        entityDescriptors
                      );
      }
  }

  render() {
    // console.log(this.props);
    // console.log(this.state.europeanaImportMethod)
    if (this.props.dataset) {
      var typeUri = '';
      if (this.props.types) {
        for (var i in this.props.types) {
           for (var j in this.props.dataset.typeUri) {
             if (this.props.types[i].uri === this.props.dataset.typeUri[j])  {
               typeUri = this.props.types[i].uri
             }
           }
         }
      }
    }

    var button = <BootstrapSwitchButton
        checked={this.props.dataset ? !this.props.dataset.public : this.state.privat}
        onlabel='Private'
        onstyle='danger'
        offlabel='Public'
        offstyle='success'
        style='w-100'
        onChange={(checked: boolean) => {
            this.setState({ privat: checked })
        }}/>

    var title = this.props.scope ? this.props.scope : this.props.type;

    return (
      <Modal show={this.props.show} onHide={this.props.onClose} animation={false} backdrop="static">
        <Form onSubmit={this.handleSubmit}>
          <Modal.Header>
            <Modal.Title>{!this.props.dataset ? 'New' : 'Edit'} {title.charAt(0).toUpperCase() + title.substr(1).toLowerCase()}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group>
              <Form.Label className="required">Name</Form.Label>
              <Form.Control ref={node => (this.name = node)}
                   onChange={() => this.setState({ error: false })}
                   pattern="\S.*"
                   defaultValue={this.props.dataset ? this.props.dataset.name : ""}
                   required/>
            </Form.Group>
            <Form.Control.Feedback type="invalid">
              Provide a valid name.
            </Form.Control.Feedback>

            <Form.Group>
              <Form.Label>Identifier</Form.Label>
              <Form.Control ref={node => (this.identifier = node)}
                   onChange={() => this.existsDatasetIdentifier()}
                   isInvalid={this.identifier && this.identifier.value && ((!this.props.dataset && this.state.identifierExists) || (this.props.dataset && this.state.identifierExists && this.props.dataset.identifier !== this.identifier.value))}
                   defaultValue={this.props.dataset ? this.props.dataset.identifier : ""}/>
              <Form.Control.Feedback type="invalid">
                   Identifier already exists or is invalid.
             </Form.Control.Feedback>
            </Form.Group>

            {this.props.visibility &&
            <Form.Group>
              <Form.Label className="required">Visibility</Form.Label>
              {button}
            </Form.Group>}
            {this.props.scope != 'SHACL' && this.props.scope != 'D2RML' && this.props.scope != 'ANNOTATOR' && this.props.scope != 'CLUSTERER' && this.props.scope != 'COMPARATOR'  && this.props.scope != 'INDEX' &&
            <Form.Group>
              <Form.Label>Datatype</Form.Label>
              <Form.Control as="select" ref={node => (this.datatype = node)}
                  defaultValue={this.props.dataset && this.props.dataset.datatype ? this.props.dataset.datatype : 'RDF'}
                  onChange={(event) => this.setState( { datatype : this.datatype.value })}>
                  <option key='0' value='FILE'>Files</option>
                  <option key='1' value='JSON'>JSON</option>
                  <option key='2' value='RDF'>RDF</option>
                </Form.Control>
            </Form.Group>}

            {/*(this.props.type === "CATALOG" || this.props.type === "DATASET") && this.props.tripleStores.length > 1 &&
            <Form.Group>
              <Form.Label className="required">Triple store</Form.Label>
              <Form.Control as="select" ref={node => (this.tripleStore = node)}
                defaultValue={this.props.dataset && this.props.dataset.tripleStore ? this.props.dataset.tripleStore : ""}>
                {this.props.tripleStores.map((entry, index) =>
                  <option key={index} value={entry}>{entry}</option>)}
              </Form.Control>
            </Form.Group>*/}

            {this.state.datatype == 'RDF' && this.state.location == 'LOCAL' &&  (this.props.scope === "COLLECTION" || this.props.scope === "VOCABULARY") && !this.props.dataset && this.props.templates && this.props.templates.length > 0 &&
              <Form.Group>
                <Form.Label>Import template</Form.Label>
                <Form.Control as="select" ref={node => (this.template = node)}
                  defaultValue=''
                  onChange={() => this.templateChanged()}>
                  <option key='0' value=''>(no template)</option>
                  {this.props.templates.map((el, index) =>
                    <option key={index + 1} value={el.id}>{el.name}</option>
                  )}
                </Form.Control>
            </Form.Group>}

            {this.state.datatype == 'RDF' && this.props.type == 'DATASET' && (this.props.scope === "COLLECTION" || this.props.scope === "VOCABULARY") &&
            <React.Fragment>
              <Form.Group>
                <Form.Label className="required">Location</Form.Label>
                <Form.Control as="select" ref={node => (this.location = node)}
                              defaultValue={this.state.location}
                              onChange={() => this.locationChanged()}>
                              required>
                    <option value="LOCAL">Local</option>
                    <option value="REMOTE">Remote</option>
                  )}
                </Form.Control>
              </Form.Group>

              {this.state.location == 'REMOTE' &&
              <React.Fragment>
                <Form.Group>
                  <Form.Label className="required">SPARQL Endpoint</Form.Label>
                  <Form.Control ref={node => (this.sparqlEndpoint = node)}
                       defaultValue={this.props.dataset && this.props.dataset.remoteTripleStore ? this.props.dataset.remoteTripleStore.sparqlEndpoint : ""}/>
                </Form.Group>

                <Form.Group>
                  <Form.Label>Named graph(s)</Form.Label>
                  <Form.Control ref={node => (this.namedGraph = node)}
                       defaultValue={this.props.dataset && this.props.dataset.remoteTripleStore && this.props.dataset.remoteTripleStore.namedGraph ? this.props.dataset.remoteTripleStore.namedGraph.join(", ") : ""}/>
                   <Form.Text className="text-muted">
                         Enter any named graphs separated by comma.
                   </Form.Text>
                </Form.Group>

                <Form.Group>
                  <Form.Label>Last updated SPARQL query</Form.Label>
                  <Form.Control ref={node => (this.lastUpdatedSparqlQuery = node)} as="textarea"
                       defaultValue={this.props.dataset && this.props.dataset.remoteTripleStore && this.props.dataset.remoteTripleStore.lastUpdatedSparqlQuery ? this.props.dataset.remoteTripleStore.lastUpdatedSparqlQuery: ""}/>
                  <Form.Text className="text-muted">
                        Enter the WHERE clause content of the SPARQL query using 'date' as the return variable.
                  </Form.Text>
                </Form.Group>
              </React.Fragment>}
            </React.Fragment>}

            {this.state.datatype == 'RDF' && this.props.type == 'DATASET' && (this.props.scope === "COLLECTION" || this.props.scope === "VOCABULARY") &&
            <Form.Group>
              <Form.Check label="Multipart" ref={node => (this.multiGroup = node)}
                defaultChecked={this.props.dataset ? this.props.dataset.multiGroup : false}
                onChange={(event) => this.setState({ multiGroup : event.target.checked})}
                disabled={this.props.dataset && this.props.dataset.multiGroup && this.props.dataset.maxGroup > 0}
                />
            </Form.Group>}

            {this.state.datatype == 'RDF' && this.props.type == 'DATASET' && (this.props.scope === "COLLECTION" || this.props.scope === "VOCABULARY") && this.state.location == 'LOCAL' &&
              <Form.Group>
                <Form.Label>Public graphs</Form.Label>
                <Form.Control ref={node => (this.publicGroups = node)}
                  defaultValue={this.props.dataset && this.props.dataset.publicGroups ? this.props.dataset.publicGroups.join(", ") : ""}
                  disabled={!this.state.multiGroup}
                  />
              </Form.Group>}



            {this.state.template && this.state.template.parameters && this.state.template.parameters.map((el, index) =>
              <Form.Group key={index}>
                <Form.Label className="required">{el.name} {el.label ? '(' + el.label + ')':''}</Form.Label>
                <Form.Control ref={node => (this['template-parameter-' + el.name] = node)}>
                </Form.Control>
              </Form.Group>
            )}

            {this.props.queryProperties &&
            <Form.Group>
              <Form.Label>View as</Form.Label>
              <Form.Control as="select" ref={node => (this.property = node)}
                            defaultValue=''
                            required>
                <option hidden disabled value=''> -- Select a property -- </option>
                {this.props.queryProperties.map((el, index) =>
                  <option key={index} value={el['@id']}>{el['@id']}</option>
                )}
              </Form.Control>
            </Form.Group>}

            {this.props.type === 'DATASET' && this.props.scope === 'VOCABULARY' &&
            <div>
              <Form.Group>
                <Form.Label>Prefix</Form.Label>
                <Form.Control ref={node => (this.prefix = node)}
                     defaultValue={this.props.dataset && this.props.dataset.entityDescriptors && this.props.dataset.entityDescriptors.length > 0 ? this.props.dataset.entityDescriptors[0].prefix : ""}/>
              </Form.Group>
              <Form.Group>
                <Form.Label>Namespace</Form.Label>
                <Form.Control ref={node => (this.namespace = node)}
                     defaultValue={this.props.dataset && this.props.dataset.entityDescriptors && this.props.dataset.entityDescriptors.length > 0 ? this.props.dataset.entityDescriptors[0].namespace : ""}/>
              </Form.Group>
            </div>}

            {this.props.types &&
            <Form.Group>
              <Form.Label>Type</Form.Label>
              <Form.Control as="select" ref={node => (this.type = node)}
//                   onChange={() => this.typeChanged()}
                   defaultValue={typeUri} required>
                   <option hidden disabled value=''> -- Select type -- </option>
                   {this.props.types.map((el, index) =>
                      <option key={index} value={el.uri}>{el.label}</option>)}
              </Form.Control>
            </Form.Group>}

            {this.props.classes &&
            <Form.Group>
              <Form.Label>Class</Form.Label>
              <Form.Control as="select" ref={node => (this.class = node)}
                   onChange={() => this.classChanged()}
                   defaultValue='' required>
                   <option hidden disabled value=''> -- Select class -- </option>
                   {this.props.classes.map((el, index) =>
                      <option key={index} value={el.uri}>{el.label}</option>)}
              </Form.Control>
            </Form.Group>}

            {this.props.vocabularies && this.class && this.class.value && this.class.value === 'http://sw.islab.ntua.gr/semaspace/model/AssertionCollection' &&
            <Form.Group>
              <Form.Label>Thesaurus/Ontology</Form.Label>
              <Form.Control as="select" ref={node => (this.ontology = node)}
                   defaultValue=''>
                   <option hidden disabled value=''> -- Select thesaurus/ontology -- </option>
                   {this.props.vocabularies.map((el, index) =>
                      <option key={index} value={el.uuid}>{el.name}</option>)}
              </Form.Control>
            </Form.Group>}


{/*            <Form.Group>
              <Form.Label>Type</Form.Label>
              <Form.Control as="select" ref={node => (this.type = node)}
                      onChange={() => this.setState({ error: false })}
                      isInvalid={false}>
                  <option hidden disabled value=''> -- Select a type -- </option>
                  <option value="data-collection">Data Collection Mapping</option>
              </Form.Control>
            </Form.Group> */}
{/*
            <Form.Group className="mb-0">
              <Form.Label className="bold">Projects</Form.Label>
              <Button type="button" className="deleteaddbutton" aria-label="New" onClick={(event) => this.addProject()}><span className="fa fa-plus"></span></Button>
            </Form.Group>

            {this.state.projects.map((el, index) =>
              <Row key={index}>
              <Col md="auto">
                <span className="bold">{index + 1}</span>
              </Col>
                <Col>
                  <Form.Group>
                    <Form.Control as="select"
                      ref={node => (this.projects[index] = node)}
                      onChange={(event) => this.projectChanged(index, event)}
                      defaultValue={el} required>
                      <option disabled value=''> -- Owned projects -- </option>
                      {this.props.myProjects.map((el2, index2) =>
                        <option key={index2} value={'m' + el2.id}>{el2.name}</option>
                      )}
                      <option disabled value=''> -- Public projects -- </option>
                      {this.props.joinedProjects.map((el2, index2) =>
                        <option key={index2} value={'p' + el2.id}>{el2.name}</option>
                      )}
                    </Form.Control>
                  </Form.Group>
                </Col>
                <Col md="auto">
                  <Button type="button" className="deleteeditbutton" aria-label="New" onClick={(event) => this.deleteTask(index)}><span className="fa fa-times"></span></Button>
                </Col>

              </Row>)*/}

          </Modal.Body>
          <Modal.Footer>
            <Button type="submit" variant="primary">
              OK
            </Button>
            <Button variant="secondary"  onClick={this.props.onClose}>
              Cancel
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
  )}
}

export default DatasetModal;
